export enum ImageTypeEnum {
  LargeHeaderNat = 'LargeHeaderNat',
}
